import h from '../h';
import { formatMonth } from '../utils';
export default function YearMonth(_ref) {
  var styles = _ref.styles,
      dates = _ref.dates,
      unit = _ref.unit,
      offsetY = _ref.offsetY,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      maxTextWidth = _ref.maxTextWidth;
  var months = dates.filter(function (v) {
    return new Date(v).getDate() === 1;
  });
  months.unshift(minTime);
  months.push(maxTime);
  var ticks = [];
  var x0 = maxTextWidth;
  var y2 = offsetY / 2;
  var len = months.length - 1;

  for (var i = 0; i < len; i++) {
    var cur = new Date(months[i]);
    var str = formatMonth(cur);
    var x = x0 + (months[i] - minTime) / unit;
    var t = (months[i + 1] - months[i]) / unit;
    ticks.push(h("g", null, h("line", {
      x1: x,
      x2: x,
      y1: 0,
      y2: y2,
      style: styles.line
    }), t > 50 ? h("text", {
      x: x + t / 2,
      y: offsetY * 0.25,
      style: styles.text3
    }, str) : null));
  }

  return h("g", null, ticks);
}